import { seoUrlEvent, slugifyUrlEntities } from '~spa/Utils/SeoUrls';
import { GTM_VIRTUALS_PAGE_BASE, GTM_VIRTUALS_PAGE_CAROUSEL } from '~spa/Pages/VirtualSports/constants';
import { navigateTo } from '~spa/Utils/NavigationAdapter';
import { rewriteUrl } from '~shared/utils/uriAliases';
import { SIZE_18x18 } from '~shared/components/icon/constants';
/**
 * Checks page type
 * @returns {Boolean} whether page is Virtual Sports
 */
export const VIRTUAL_SPORTS_SLUG = 'virtual-sports';
export const VIRTUAL = 'virtual-';
export const isVirtualSportsPage = (currentUrlPath) => {
    return Boolean(currentUrlPath.includes(VIRTUAL_SPORTS_SLUG));
};

const baseGtmAttribute = `${GTM_VIRTUALS_PAGE_BASE};${GTM_VIRTUALS_PAGE_CAROUSEL};`;

export const normalizeCarouselTabsData = (games, gameId = 0) => (
    games.map((event, index) => {
        let gameSlug = '';
        if ((event.game_slug).includes(VIRTUAL) ) {
            gameSlug = (event.game_slug).replace(VIRTUAL, '');
        }
        const gtmAttribute = `${baseGtmAttribute}${event.game_slug}`;

        return ({
            label: event.game_name,
            selected: index === gameId,
            icon: gameSlug || event.game_slug, gtmAttribute,
            iconSize: SIZE_18x18,
            fluid: true,
        });
    })
);

export const getFullUrl = (game) => {
    let path = '';
    const { game_name, tournament_name, category_name, sport_name } = game;
    [sport_name, category_name, tournament_name, game_name].forEach(item => {
        path += `${slugifyUrlEntities(item)}/`;
    });

    return seoUrlEvent(path, game.event_id);
};

export const updateUrlOnTabChange = (game) => {
    const eventUrl = getFullUrl(game);
    window.history.pushState(null, null, rewriteUrl(eventUrl));
    navigateTo(eventUrl);
};
